import Choices from 'choices.js'
import Vue from 'vue'
import EventBus from '../_event-bus'

Vue.component('vue-prize-sorter', {
  template: '#vue-prize-sorter-template',
  methods: {
    initChoices,
    addSelectListener,
  },
  mounted() {
    this.addSelectListener()
    this.initChoices()
  },
})

function addSelectListener() {
  this.$refs.select.addEventListener('choice', handleChoice)
}

function handleChoice(event) {
  EventBus.$emit('sort-prizes', event.detail.choice.value)
}

function initChoices() {
  new Choices(this.$refs.select, {
    itemSelectText: '',
    searchEnabled: false,
    shouldSort: false,
  })
}
